/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";

import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Filtros {
  inicioIntervaloCadastroLead?: string;
  fimIntervaloCadastroLead?: string;
  inicioIntervaloAtualizacaoLead?: string;
  fimIntervaloAtualizacaoLead?: string;
  idsMotivosDesqualificacaoLeadSistemaOrigem?: string[];
  leadCliente?: boolean;
  leadVisitouEmpreendimento?: boolean;
  leadPassouPelaOfertaAtiva?: boolean;
  quantidadeVezesLeadPassouPelaOfertaAtiva?: number;
  idsOrigensLeadSistemaOrigem?: string[];
  idsCanaisLeadSistemaOrigem?: string[];
  idsTemperaturasLeadSistemaOrigem?: string[];
  idsRendasFamiliaresLeadSistemaOrigem?: string[];
  etapas?: string[];
  idsSubetapasSistemaOrigem?: string[];
  etapasAnterioresLead?: string[];
  idsSubEtapasAnterioresLeadSistemaOrigem?: string[];
  idsProdutosInteresseSistemaOrigem?: string[];
  apenasLeadsSemProdutos?: boolean;
  idsTiposEmpreendimentosSistemaOrigem?: string[];
  quantidadesDormitorios?: number[];
  idsZonasEmpreendimentosSistemaOrigem?: string[];
  idsBairrosEmpreendimentosSistemaOrigem?: string[];
  inicioIntervaloValorImovel?: string;
  fimIntervaloValorImovel?: string;
  idsObjetivosCompraSistemaOrigem?: string[];
  idsPrazosEntregaSistemaOrigem?: string[];
}

interface Props {
  nome: string;
  descricao: string;
  campanhaAtiva: boolean;
  idsCorretorSistemaOrigem: string[];
  filtros: Filtros;
}

export function useCriarCampanha() {
  const postData = async (props: Props) => {
    const CRIAR_CAMPANHA = `${leadsWebEnviroment}/common/campanha/v1`;
    const response = await instance.post(CRIAR_CAMPANHA, {
      nome: props.nome,
      descricao: props.descricao,
      campanhaAtiva: props.campanhaAtiva,
      idsCorretorSistemaOrigem: props.idsCorretorSistemaOrigem,
      filtros: props.filtros,
    });
    return response?.data?.data;
  };
  const mutation = useMutation({
    mutationFn: postData,
    onSuccess: () => {},
    onError: () => {},
  });

  return mutation;
}
